<template>
  <div
    :class="
      isEdgeToEdge &&
      'pt-[env(safe-area-inset-top)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]'
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useHead, useRoute } from '#imports'

const route = useRoute()
const isEdgeToEdge = route.meta.shouldDisplayEdgeToEdge

useHead(() =>
  isEdgeToEdge
    ? {
        meta: [
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1, viewport-fit=cover',
          },
        ],
      }
    : {},
)
</script>
